import { FloatingButtonAction } from '@fb/models/action.model';
import { IconSource } from '@hglobal/common';

export interface FloatingButtonConfig {
  blockAiChat: boolean;
  translations: Record<string, string>;
  icons: Record<string, IconSource>;
  actions: FloatingButtonAction[];
}
